import React, { useEffect, useState } from 'react';
import { Tabs } from '@vacasa/react-components-lib';
import { useNavigate } from 'react-router-dom';
import { ExternalSync } from '../ExternalSync/ExternalSync';
import { GuestContentRevalidate } from '../GuestContentRevalidate/GuestContentRevalidate';
import { UnitSync } from '../UnitSync/UnitSync';
import { ReviewSummaries } from '../ReviewSummaries/ReviewSummaries';
import { QueueTypes } from '../ReviewsTable/WorkQueue.utils';
import './UtilTools.scss';

// Path strings (not AppRoutes from Router) to avoid circular import: UtilTools → Router → Home → UtilTools.
const UTIL_SUB_TABS = [
    {
        id: 'external-sync',
        label: 'External Reviews Sync',
        path: '/external-sync',
        type: QueueTypes.EXTERNAL_SYNC,
        component: <ExternalSync />,
    },
    {
        id: 'guest-content-revalidate',
        label: 'Guest Content',
        path: '/guest-content-revalidate',
        type: QueueTypes.GUEST_CONTENT_REVALIDATE,
        component: <GuestContentRevalidate />,
    },
    {
        id: 'unit-sync',
        label: 'Unit Sync',
        path: '/unit-sync',
        type: QueueTypes.UNIT_SYNC,
        component: <UnitSync />,
    },
    {
        id: 'review-summaries',
        label: 'Review Summaries',
        path: '/review-summaries',
        type: QueueTypes.REVIEW_SUMMARIES,
        component: <ReviewSummaries />,
    },
] as const;

const utilSubTabIndex = (queueType?: QueueTypes): number => {
    const index = UTIL_SUB_TABS.findIndex((tab) => tab.type === queueType);
    return index >= 0 ? index : 0;
};

interface UtilToolsProps {
    queueType?: QueueTypes;
}

export const UtilTools: React.FC<UtilToolsProps> = ({ queueType }) => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(() => utilSubTabIndex(queueType));

    useEffect(() => {
        setSelectedTab(utilSubTabIndex(queueType));
    }, [queueType]);

    const onChange = (index: number) => {
        setSelectedTab(index);
        navigate(UTIL_SUB_TABS[index].path, { replace: true });
    };

    return (
        <div className="util-tools">
            <Tabs variant="default" selected={selectedTab} customClass="util-tools-tabs" tabs={[...UTIL_SUB_TABS]} onChange={onChange} />
        </div>
    );
};
